import sendLocalRequest from "./sendLocalRequest";

export const getSerialNumbers = (auth_token) => {
    return  new Promise( (resolve, reject) => {
        sendLocalRequest("get_serial_numbers", "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
